import axios from 'axios'
import { getToken } from './tokenCheck'
import jwt_decode from 'jwt-decode'
import store from '../store'

const ServiceCandidate = axios.create({
  // baseURL:"https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/candidate/", // Dev Gateway
  // baseURL: "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/candidate/", // Staging
  baseURL: "https://gateway.hire3x.com/candidate/", // Production gateway
});

const ServiceCandidateDirect = axios.create({
  baseURL: 'https://candidate-api.hire3x.com',
})

const ServiceCandidateParser = axios.create({
  baseURL: "https://resumeparser.hire3x.com",
});
const SSOService = axios.create({
  // baseURL: "https://auth.simplifymycareer.com/", // Staging & Development
  baseURL: "https://auth.hire3x.com/", // Production
});

const request = axios.create({
  // baseURL:
  // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/recruitment/", // Dev Gateway
  // baseURL: "https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/recruitment/", // Staging gateway
  baseURL: "https://gateway.hire3x.com/recruitment/", // Production gateway
});
const KeycloakAPIs = axios.create({
  // baseURL: "https://keynode.simplifycv.com/", // Development
  // baseURL: "https://keynode.simplifymycareer.com/", // Staging
  baseURL: "https://keynode.hire3x.com/", // Production
});
const trainingServe = axios.create({
  baseURL:
    // baseURL: "https://training-api.simplifycv.com/", // development
    // "https://training-api.simplifymycareer.com/" // staging
    "https://training-api.hire3x.com/", //  Production gateway
});

const requestrbac = axios.create({
  baseURL:
    // "https://9vrcuz6g0c.execute-api.ap-south-1.amazonaws.com/dev-ass/rbac/access/", // Dev Gateway
    // " https://ablrb41ade.execute-api.ap-south-1.amazonaws.com/trial/rbac/access/", // Staging gateway
    "https://gateway.hire3x.com/rbac/access/", // Production gateway
  // baseURL: "http://rbac.simplifymycareer.com/access/access/",
  // baseURL: "http://127.0.0.1:8002/access/",
})

const requestSuggestion = axios.create({
  baseURL: "https://suggestions.simplifycv.com/", // Dev Gateway
  // baseURL: "https://suggestions.simplifymycareer.com/", // Staging gateway
  // baseURL: "https://recruitment-api.simplifycv.com/", // Staging gateway
});

requestrbac.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    return config
  },
  (error) => {
    return error;
  },
);

request.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    // config.headers["userID"] = getProcessedToken();
    return config
  },
  (error) => {
    // Do something with request error
    return error;
  },
);
KeycloakAPIs.interceptors.request.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + getToken()
    // config.headers["userID"] = getUserID();
    return config
  },
  (error) => {
    return error;
  },
);
ServiceCandidate.interceptors.request.use(
  (body) => {
    body.headers['Authorization'] = 'Bearer ' + getToken()
    // body.headers["userID"] = getProcessedToken();
    return body
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  },
);

ServiceCandidateDirect.interceptors.request.use(
  (body) => {
    body.headers['userID'] = getProcessedToken()
    return body
  },
  (error) => {
    console.error(error)
    Promise.reject(error)
  },
)

requestSuggestion.interceptors.request.use(
  (body) => {
    // body.headers["Authorization"] = "Bearer " + getToken();
    body.headers["userID"] = getProcessedToken();
    return body;
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  },
);

ServiceCandidateParser.interceptors.request.use(
  (body) => {
    body.headers['userID'] = getProcessedToken()
    return body
  },
  (error) => {
    console.error(error);
    Promise.reject(error);
  },
);
trainingServe.interceptors.request.use(
  (body) => {
    // body.headers["Authorization"] = "Bearer " + getToken();
    // body.headers["userID"] = getProcessedToken();
    body.headers['userID'] = store.getters['userVUEX/getSelectedId']
    return body
  },
  (error) => {
    Promise.reject(error);
  },
);
// const getProcessedToken = () => {
//   var decoded = jwt_decode(localStorage.getItem("vue_token"));
//   return decoded.sub;
// };
const getProcessedToken = () => {
  var decoded = jwt_decode(getToken())
  return decoded.sub
}

// const getToken = () => {
//   return localStorage.getItem("vue_token");
// };
export {
  ServiceCandidate,
  ServiceCandidateDirect,
  SSOService,
  request,
  requestrbac,
  KeycloakAPIs,
  ServiceCandidateParser,
  trainingServe,
  requestSuggestion,
};
